var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveLoad(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 7.149-1.743 1.048C10.047.677 0 0 0 0c7.185 2.496 10.005 8.412 10.742 10.323l-1.927 1.155L16 16V7.149z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.505 12.442c.253.15.529.225.828.225.3 0 .576-.075.829-.225.253-.15.454-.35.603-.604.15-.252.225-.529.225-.828 0-.3-.075-.579-.225-.838a1.67 1.67 0 0 0-.603-.614 1.596 1.596 0 0 0-.829-.225c-.3 0-.575.075-.828.225a1.67 1.67 0 0 0-.604.614 1.65 1.65 0 0 0-.224.838c0 .3.075.575.224.828.15.253.351.455.604.604zm2.186 1.243a5.775 5.775 0 0 0-1.358-.18c-.412 0-.865.06-1.357.18-.559.14-1.011.326-1.357.559-.413.272-.619.578-.619.918V16h6.667v-.838c0-.34-.207-.646-.62-.918-.345-.233-.797-.42-1.356-.56z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveLoad);
export default __webpack_public_path__ + "static/media/live_load.125c422ed918d9fc7363cd89aa020026.svg";
export { ForwardRef as ReactComponent };